
<div>
  <canvas-backdrop [Context]="Context" (Clicked)="BackdropPressed.emit($event)">
  </canvas-backdrop>

  <div #panel [@slideInOut] class="overlay-panel" [ngClass]="Type">
  <div (click)="BackdropPressed.emit($event)" id="closeButton" class="absolute cursor-pointer right-4 top-8 h-[46px] w-[46px] bg-[#EBEBEB] border-solid border-[1px] border-[#E9E5E3] rounded-[12px] p-4">
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 1L6 6M1 11L6 6M6 6L1 1M6 6L11 11" stroke="#041A11" stroke-width="1.5" stroke-linecap="round"/>
      </svg>

  </div>
    <ng-content></ng-content>
  </div>
</div>

